<template>
  <form ref="form" @submit.prevent>
    <b-row>
      <b-col :md="12" :lg="6">
        <b-card :title="$t('companies.application')">
          <fields ungrouped />

          <fields group="ride_types" class="ride_types" />

          <radius-field
            v-if="isFormLoaded && model.ride_types.includes('city_taxi')"
            :address-field="fields.get('address')"
            :radius-field="fields.get('city_taxi_radius')"
            :model="model"
          />

          <radius-field
            v-if="isFormLoaded && model.ride_types.includes('delivery')"
            :address-field="fields.get('delivery_area_center')"
            :radius-field="fields.get('delivery_radius')"
            :model="model"
          />
        </b-card>

        <b-card>
          <vehicles-list-edit
            v-if="isFormLoaded"
            v-model="model.vehicles"
            :ride-types="enabledRideTypes"
            :vehicles="vehicles"
          />
        </b-card>
      </b-col>
      <b-col :md="12" :lg="6">
        <b-card :title="$t('companies.billing')">
          <fields group="billing" />
        </b-card>
        <b-card>
          <fields group="airports" layout="vertical" />
        </b-card>
      </b-col>
    </b-row>
    <div>
      <b-button type="button" variant="danger" class="ml-2" @click="deleteItem">
        {{ $t('general.delete') }}
      </b-button>
      <b-button type="button" variant="success" class="ml-2" @click="accept">
        {{ $t('general.accept') }}
      </b-button>
    </div>
  </form>
</template>

<script>
import { ResourceFormMixin } from 'stylemix-vue-admin'
import ApplicationApi from './ApplicationApi'
import TimeZones from '../components/timezones.json'
import RadiusField from '../components/fields/RadiusField'
import VehiclesListEdit from '../companies/VehiclesListEdit'
import FormMixin from './FormMixin'

export default {
  name: 'CompanyForm',
  components: { RadiusField, VehiclesListEdit },

  mixins: [ResourceFormMixin, FormMixin],
  props: {
    showCancelButton: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      base: 'company-applications',
      isFormLoaded: false,
      rideTypes: [],
      timezones: [],
      vehicles: [],
    }
  },

  computed: {
    enabledRideTypes() {
      return this.rideTypes.filter(t => {
        return this.model.ride_types.includes(t.value)
      })
    },
  },

  created() {
    for (let timezone of TimeZones) {
      this.timezones.push({
        label: timezone.text,
        value: timezone.utc[0],
      })
    }
  },

  mounted() {
    this.loadForm().then(result => {
      this.fields.get('timezone').options = this.timezones
      this.vehicles = result.vehicles
      this.rideTypes = result.ride_types
      this.isFormLoaded = true

      this.setFieldGroup('ride_types', ['ride_types'])
      this.setFieldGroup('hidden', ['vehicles'])
    })
  },

  methods: {
    api() {
      return new ApplicationApi({
        division_id: this.currentDivision.id,
      })
    },

    accept() {
      let promise = this.api().accept(this.model)
      this.$uiBlocker(promise, this.$refs.form)
      promise
        .then(result => {
          this.$toast.success(result.message)
          this.$emit('accepted', result.data)
        })
        .catch(response => {
          this.onSaveError(response)
        })
      this.$uiBlocker(promise, this.$refs.form)
    },

    deleteItem() {
      let promise = this.api().destroy(this.model.id)
      this.$uiBlocker(promise, this.$refs.form)
      promise
        .then(result => {
          this.$toast.success(result.message)
          this.$emit('deleted', result.data)
        })
        .catch(response => {
          this.onSaveError(response)
        })
    },
  },
}
</script>
